exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton.owl-dot[data-v-a48b9be2]:focus {\n    outline: 0 !important;\n}\n", ""]);

// exports
